import type { ContentItem } from "../content/types";
import { ContactForm } from "../components/ContactForm";
import { RichContent } from "../components/RichContent";

type HelpPageProps = { page: ContentItem };

export function HelpPage({ page }: HelpPageProps) {
  return (
    <>
      <header className="page-head">
        <div className="wrap page-head__narrow">
          <p className="index-label"><span className="index-label__number">Support</span><span>Website and purchases</span></p>
          <h1 className="display">How can we help?</h1>
          <p className="page-head__lede">Use this form for website, payment, or consultation support. For aquarium troubleshooting, request a consultation instead.</p>
        </div>
      </header>
      <section className="form-layout wrap">
        <div className="form-layout__intro">
          <RichContent html={page.contentHtml} />
          <div className="direct-contact">
            <p className="index-label"><span className="index-label__number">Prefer email?</span></p>
            <a href="mailto:support@aquariumhelpline.com">support@aquariumhelpline.com</a>
          </div>
        </div>
        <ContactForm variant="support" />
      </section>
    </>
  );
}
